module.exports = __webpack_public_path__ + "img/lishirenwu@2x.ed55b6f7.png";